import classes from './UserInitials.module.css'

const UserInitials = ({ firstName = '', lastName = '', className = '' }) => {
    
    const initials = `${firstName?.trim()?.charAt(0) ?? ''}${lastName?.trim()?.charAt(0) ?? ''}`

    if (!initials) {
        return null
    }

    return (
        <span className={`${classes.UserInitials} ${className}`}>
            {initials}
        </span>
    )
}

export default UserInitials
